import { H8Bold, px2rem } from "@moim/common";
import { Svg18RightarrowG } from "@moim/icons";
import styled from "styled-components";
import React from "react";
import { FormattedMessage } from "react-intl";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled(H8Bold)`
  color: ${props => props.theme.colorV2.colorSet.grey800};

  padding: ${px2rem(11)} ${px2rem(8)} ${px2rem(11)} ${px2rem(16)};
  flex: 1;
  min-width: 0;
`;

export const RightArrow = styled(Svg18RightarrowG).attrs(props => ({
  size: "xs",
  touch: 42,
  iconColor: props.theme.colorV2.colorSet.grey300,
}))``;

interface PropsType {
  userId?: string;
  hasNFT: boolean;
}
export const Header: React.FC<PropsType> = React.memo(({ hasNFT }) => {
  const handleBackButtonClick = React.useCallback(() => {}, []);

  return (
    <Wrapper
      onClick={handleBackButtonClick}
      role={hasNFT ? "button" : undefined}
    >
      <Title>
        <FormattedMessage id="nft_list_title" />
      </Title>
      {hasNFT && <RightArrow />}
    </Wrapper>
  );
});
